import { api } from '../DefaultService';
import { IOnlineModeSimpleProps, IOnlineModeUpdateParams } from './types';
import {
  IDefenseProps,
  IDefenseUpdateParams,
} from '../IntegrationService/DefenseService/types';

const ENDPOINT = '/v1/licenses/onlinemode';

export const getOnlineModeByIdAsync =
  async (): Promise<IOnlineModeSimpleProps> => {
    return await api
      .get(`${ENDPOINT}`)
      .then((response) => response.data)
      .catch((error) => {
        throw new Error(
          error?.response?.data?.message || 'Erro interno do servidor!',
        );
      });
  };

export const updateOnlineModeAsync = async ({
  data,
}: IOnlineModeUpdateParams): Promise<IOnlineModeSimpleProps> => {
  return await api
    .put(`${ENDPOINT}`, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};
